import http from '../../core/services/http'

export const generateMenuDistributionAgeReport = ({ menuType, period }) => {
  const params = new URLSearchParams({ period, menuType })
  return http.get(`/reports/menu-distribution-age?${params}`, {
    responseType: 'blob',
  })
}
